import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'
import { OptionCard } from '../components'
import useKeyboardNavigation from '../../../hooks/useKeyboardNavigation'

const GoalsPage = ({
  introText,
  title,
  subtitle,
  goals,
  selectedGoals,
  onToggleGoal,
  questionNumber,
  totalQuestions
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const titleParts = title.split('\n')

  const { focusedIndex, handleKeyDown } = useKeyboardNavigation(
    goals.length,
    isMobile ? 1 : 2,
    (index) => onToggleGoal(goals[index])
  )

  return (
    <Box className={classes.content} data-test='goals-page' onKeyDown={handleKeyDown}>
      {introText && (
        <Typography
          className={classes.introBanner}
          data-test='goals-page-intro'
        >
          {introText.split('\n').map((part, index, arr) => (
            <React.Fragment key={index}>
              {part}
              {index < arr.length - 1 && <br />}
            </React.Fragment>
          ))}
        </Typography>
      )}
      {totalQuestions > 0 && (
        <Typography
          className={classes.inlineQuestionCounter}
          data-test='goals-page-question-counter'
        >
          {`Question ${questionNumber} of ${totalQuestions}`}
        </Typography>
      )}
      <Typography
        id='lpq-dialog-title'
        className={classes.question}
        data-test='goals-page-title'
        component='h2'
      >
        {titleParts.map((part, index) => (
          <React.Fragment key={index}>
            {part}
            {index < titleParts.length - 1 && <br />}
          </React.Fragment>
        ))}
      </Typography>
      {subtitle && (
        <Typography
          id='lpq-dialog-description'
          className={classes.subtitle}
          data-test='goals-page-subtitle'
        >
          {subtitle}
        </Typography>
      )}
      <Box
        className={classes.goalsGrid}
        data-test='goals-grid'
        role='group'
        aria-label='Goal selection options'
      >
        {goals.map((goal, index) => (
          <OptionCard
            key={goal}
            text={goal}
            isSelected={selectedGoals.includes(goal)}
            onClick={() => onToggleGoal(goal)}
            variant='goals'
            isFocused={focusedIndex === index}
            onKeyDown={handleKeyDown}
          />
        ))}
      </Box>
    </Box>
  )
}

export default GoalsPage
